/* eslint-disable no-template-curly-in-string */
import { setLocale } from 'yup';

setLocale({
  mixed: {
    default: 'Não é válido',
    required: 'Este campo é obrigatório',
  },
  string: {
    email: 'Este não é um email válido',
    max: 'O máximo de caracteres deve ser ${max}',
    min: 'O mínimo de caracteres deve ser ${min}',
  },
  number: {
    min: 'Deve ser maior que ${min}',
    integer: 'O número deve ser inteiro',
    positive: 'O número deve ser positivo',
    negative: 'O número deve ser negativo',
  },
  date: {
    max: 'A data máxima é até ${max}',
    min: 'A data mínima é até ${min}',
  },
});
